// extracted by mini-css-extract-plugin
export default {"card":"card--xm8s3EZZ"};